import { FORM_VALID } from '@ds/components/Form'

export function isAtLeast18(birthdate: Date): boolean {
  const today = new Date()

  // Calculate the difference in years
  let age = today.getFullYear() - birthdate.getFullYear()

  const isBirthdayLaterThisYear =
    today.getMonth() < birthdate.getMonth() ||
    (today.getMonth() === birthdate.getMonth() &&
      today.getDate() < birthdate.getDate())

  if (isBirthdayLaterThisYear) {
    age -= 1
  }

  return age >= 18
}

export function atLeast18YearsOld(message: string) {
  return (value: unknown) =>
    typeof value === 'string' && isAtLeast18(new Date(value))
      ? FORM_VALID
      : message
}
